import { Component, OnInit } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import {Router} from '@angular/router';
import {PopoverController} from '@ionic/angular';
import {HomePopOverComponent} from '../../components/home-pop-over/home-pop-over.component';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {Contract, User} from '../../../models';
import {Predicates} from 'aws-amplify';
import {SessionService} from '../../services/session.service';

@Component({
  selector: 'app-home2',
  templateUrl: './home2.page.html',
  styleUrls: ['./home2.page.scss'],
})
export class Home2Page implements OnInit {
    sortDirection = SortDirection.ASCENDING;
  usersCount: number;
  contractsCount: number;
    cssClass: any;

  constructor(
    private router: Router,
    public navController: NavController, 
    public popoverController: PopoverController,
    public session:SessionService,
  ) { }

  async ngOnInit() {
    const users = await DataStore.query(User,  Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        });
    this.usersCount = users.length;
    const contracts = await DataStore.query(Contract);

    this.contractsCount = contracts.length;
  }

  async ionViewDidEnter() {
    // make sure the newly styled content scrolls when needed
    document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
}

  openPage(page: string) {
    return this.router.navigate([page]);
  }  

  async showModal(ev: any) {
    const popover = await this.popoverController.create({
        component: HomePopOverComponent,
        event: ev,
        translucent: true,
        componentProps: {
            "type": "homeOptions"
        }
    });
    return await popover.present();
}

  back() {
    this.navController.back();
  }

}
